import styled from "styled-components";

export const PaginationWrapper = styled.div`
  display: ${({ $show }) => $show ? 'flex' : 'none'};
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 40px;
  /* padding: 2px 8px; */

  @media only screen and (max-width: 768px) {
    gap: 10px;
  }
`;

export const PageDropdownContainer = styled.div`
  position: relative;
  left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  @media only screen and (max-width: 1024px) {
    position: relative;
    left: auto;
  }

  p {
    font-size: 12px;
    color: var(--text-color-primary);
  }

  .MuiFormControl-root {
    margin: 0;
    .MuiInputBase-root {
      border-radius: 3rem;
      font-size: 12px;
      color: var(--theme-color-primary);

      svg {
          width: 0.7em;
          height: auto;
          top: calc(50% - .35em);
          color: var(--theme-color-primary);
        }

      .MuiSelect-select {
        padding-top: 4px;
        padding-bottom: 4px;
        padding-left: 12px;
        padding-right: 22px;
      }

      fieldset {
        border-color: var(--theme-color-primary);
      }
    }
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;

  @media only screen and (max-width: 600px) {
    gap: 4px;
  }

  svg {
    width: 22px;
    height: auto;

    @media only screen and (max-width: 600px) {
      width: 18px;
    }
  }
`;

export const PaginationButton = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition: all ease-in-out 0.2s;

  @media only screen and (max-width: 600px) {
    width: 30px;
    height: 30px;
  }

  &.pagination-button {
    background-color: transparent;
    color: var(--theme-color-primary);
    border: 1px solid var(--theme-color-primary);

    &:not(:disabled):hover {
      background-color: var(--theme-color-primary);
      color: var(--theme-color-white);
    }

    &:disabled {
      filter: grayscale(1);
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  &.pagination-action {
    background-color: var(--theme-color-primary);
    color: var(--theme-color-white);
    border: 1px solid var(--theme-color-primary);

    &:not(:disabled):hover {
      transform: scale(1.05);
    }

    &:disabled {
      filter: grayscale(1);
      opacity: 0.4;
      background-color: transparent;
      color: var(--theme-color-primary);
      cursor: not-allowed;
    }
  }

  &.pagination-item {
    background-color: transparent;
    color: var(--text-color-primary);
    border: 1px solid var(--border-color);

    &:hover {
      border-color: var(--theme-color-primary);
    }
  }

  &.pagination-item-selected {
    background-color: var(--theme-color-primary);
    color: var(--theme-color-white);
    border: 1px solid var(--theme-color-primary);
  }

  .dark-mode &.pagination-button:disabled,
  .dark-mode &.pagination-action:disabled {
    opacity: 0.6;
  }
`;